import React from 'react';
import { I18n } from '../../../utils/I18n/I18n';
import { useListingContext } from '../../../context/ListingContext';

/**
 * Sort codes that should expose both ASC and DESC directions in the dropdown.
 * Other codes (popularity, position) get a single entry with a fixed direction
 * defined in DEFAULT_DIRECTIONS — Magento sort_fields carries no direction info.
 */
const DIRECTIONAL_CODES = ['price', 'name'];

const DEFAULT_DIRECTIONS = {
    popularity: 'DESC',
};

const LABEL_OVERRIDE_KEYS = {
    position: 'category.preporuka',
};

const expandOptions = (options, t) => options.flatMap((opt) => {
    if (DIRECTIONAL_CODES.includes(opt.value)) {
        return [
            {
                value: `${opt.value}-ASC`,
                label: `${t('category.sortBy')} ${t(`category.${opt.value}Asc`)}`,
            },
            {
                value: `${opt.value}-DESC`,
                label: `${t('category.sortBy')} ${t(`category.${opt.value}Desc`)}`,
            },
        ];
    }

    const label = LABEL_OVERRIDE_KEYS[opt.value] ? t(LABEL_OVERRIDE_KEYS[opt.value]) : opt.label;

    return [{value: opt.value, label}];
});

const SortProducts = () => {
    const {sortFields, listingParams, setListingParams} = useListingContext();

    if (!sortFields || !sortFields.options || sortFields.options.length === 0) {
        return null;
    }

    const buildSortValue = ([code, dir]) => (
        DIRECTIONAL_CODES.includes(code) ? `${code}-${dir}` : code
    );

    const sortEntry = Object.entries(listingParams.sort || {})[0];
    const currentValue = sortEntry ? buildSortValue(sortEntry) : (sortFields.default || '');

    const onChange = (e) => {
        const raw = e.target.value;
        const [code, dirFromValue] = raw.includes('-') ? raw.split('-') : [raw, null];
        const dir = dirFromValue || DEFAULT_DIRECTIONS[code] || 'ASC';

        setListingParams({
            ...listingParams,
            currentPage: 1,
            sort: code ? {[code]: dir} : {},
        });
    };

    return (
        <I18n>
            {t => (
                <div className="sortBySection">
                    <div className="sortByOptions">
                        <select value={currentValue} onChange={onChange}>
                            {expandOptions(sortFields.options, t).map((opt) => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                        </select>
                    </div>
                </div>
            )}
        </I18n>
    );
};

export default SortProducts;
